<template>
    <el-main>
        <el-tabs v-model="searchNav" type="">
            <el-tab-pane label="线下渠道" name="source">
                <el-form :inline="true" ref="form" :model="sourceForm" label-width="80px">
                    <el-date-picker
                        class="daterange mr8"
                        v-model="uploadForm.date_range"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="上传批次" name="upload">
                <el-form :inline="true" ref="form" :model="uploadForm" label-width="80px">
                    
                </el-form>
            </el-tab-pane>
        </el-tabs>

        <div class="delimiter"></div>

        <el-table
            id="out-table"
            :data="tableData"
            border
            class="table"
            ref="multipleTable"
            header-cell-class-name="table-header"
            v-loading="loading"
        >
            <el-table-column prop="user.realname" label="员工"></el-table-column>
            <el-table-column v-if="searchNav == 'source'" prop="account.title" label="渠道"></el-table-column>
            <el-table-column prop="total" label="客资总数"></el-table-column>
            <el-table-column prop="no_visited" label="未跟进"></el-table-column>
            <el-table-column prop="no_connected" label="未接通"></el-table-column>
            <el-table-column label="接通率"></el-table-column>
            <el-table-column prop="valid" label="有效数"></el-table-column>
            <el-table-column label="有效率"></el-table-column>
        </el-table>
    </el-main>
</template>

<script>
const sourceForm = {
    source_account_id: '',
    user_id: [],
    date_range: []
};

const uploadForm = {
    upload_id: [],
    user_id: [],
};

export default {
    namespaced: true,
    name: 'WashGroupChart',
    data() {
        return {
            searchNav: 'source',
            loading: false,
            tableData: [],
            sourceForm: Object.assign({}, sourceForm),
            uploadForm: Object.assign({}, uploadForm),
        };
    },
    beforeMount() {
        this.dictionary = dictionary;
    },
    created() {
        this.height = window.innerHeight * 0.75;
    },
    methods: {
        getTableData() {
           
        },
    }
};
</script>

<style lang="less" scoped>
.delimiter {
    height: 20px;
}
</style>
